module.exports = __webpack_public_path__ + "static/FS-Barrier-1-6-1d9ed9b131f0ba3ec6ad4ae8202dc9cc.png";